import { useState } from "react";

// components
import { Box, Container, Tab, Tabs } from "@mui/material";
import { tabStyle } from "utils/styles";
import { ServiceComp, TabPanel } from "utils/unitComponent";

import { upperFirst } from "lodash";

// ----------------------------------------------------------------------

export default function Shuttle() {
	const nav = [
		{ label: "Intro", value: "intro" },
		{ label: "F&B", value: "fb" },
		{ label: "E-ticket", value: "ticket" },
		{ label: "Locker", value: "locker" },
		// { label: 'etc.', value: 'etc' },
	];
	const [value, setValue] = useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	return (
		<Container
			sx={{
				py: 20,
				display: "flex",
				flexDirection: "column",
			}}
		>
			{/* <!-- 개인정보 처리방침 --> */}
			<article>
				<h1 style={{ marginBottom: 12 }}>개인정보 처리방침</h1>
				<p>
					<strong>퀸즈스마일</strong>(이하 “회사”)는 「개인정보 보호법」 등 관련
					법령을 준수하며, 셔틀버스 위치 안내 서비스 제공 과정에서 이용자의
					개인정보를 안전하게 처리합니다.
				</p>

				<p class="meta">
					<strong>시행일:</strong> 2025-08-22
					<br />
					<strong>최종개정:</strong> 2025-08-22
				</p>

				<section style={{ margin: "12px 0" }} class="section" id="collect">
					<h2>1. 수집 항목 및 수집 방법</h2>

					<h3>1) 공통 수집 항목(필수)</h3>
					<ul>
						<li>계정 식별 정보: 휴대전화</li>
						<li>
							기기·접속 정보: OS/앱 버전, 기기 모델, 광고 ID 또는 푸시 토큰, IP,
							로그(오류/이벤트)
						</li>
					</ul>

					<h3>2) 역할별 수집 항목</h3>
					<ul>
						<li>
							<strong>기사앱(운행 단말)</strong>: 정밀 위치정보(위도/경도),
							백그라운드 위치, 이동속도/방향, 운행 노선·차량 ID, 운행
							상태(출발/도착 등)
						</li>
					</ul>

					<h3>3) 수집 방법</h3>
					<ul>
						<li>
							운행 등록 시 입력, 앱 권한 동의 후 자동 수집, 고객센터 접수, 로그
							수집 SDK
						</li>
					</ul>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="purpose">
					<h2>2. 처리 목적</h2>
					<ul>
						<li>
							실시간 셔틀 위치 지도 표시, 도착 예측(ETA), 노선/정류장 안내,
							탑승인원 관리
						</li>
						<li>
							안전·보안(부정 사용 방지, 이상 운행 탐지), 오류 대응 및 서비스
							품질 개선
						</li>
						<li>공지/고객지원, 분쟁 대응, 법령상 의무 이행</li>
					</ul>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="retention">
					<h2>3. 보유·이용 기간</h2>
					<ul>
						<li>계정정보: 탈퇴 시 6개월간 보관 후 파기</li>
						<li>
							위치 데이터: 실시간 제공 및 품질 개선을 위한 원시 위치
							로그(보관기간: 6개월), 통계·분석자료는 비식별화하여 2년 보관
						</li>
						<li>
							민원·분쟁 기록: 「전자상거래법」 등 관계 법령에 따라 최대 3~5년
							보관
						</li>
					</ul>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="thirdparty">
					<h2>4. 제3자 제공</h2>
					<p>
						회사는 원칙적으로 동의 없이 개인정보를 외부에 제공하지 않습니다.
						다만 법령 근거가 있거나, 서비스 제공을 위해 필요한 경우{" "}
						<strong>사전 고지 및 동의</strong> 후 아래 범위에서 제공할 수
						있습니다.
					</p>
					<ul>
						<li>제공받는 자: [운영 위탁사/관제센터/관할 기관 등]</li>
						<li>제공 목적: 운행 관제, 고객지원, 사고·민원 처리</li>
						<li>제공 항목/보유기간: [항목], [기간]</li>
					</ul>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="outsourcing">
					<h2>5. 처리의 위탁</h2>
					<p>안정적 서비스 제공을 위해 다음 업무를 위탁할 수 있습니다.</p>
					<ul>
						<li>
							수탁업체: [클라우드 제공사], [푸시 발송사], [로그 분석 SDK 제공사]
						</li>
						<li>위탁업무: 인프라 운영, 메시지 발송, 오류·사용성 분석</li>
						<li>보유·이용 기간: 위탁계약 종료 시까지 또는 법정 보관기간</li>
					</ul>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="overseas">
					<h2>6. 국외 이전(해당 시)</h2>
					<p>
						데이터가 해외 서버에 저장·처리되는 경우: 이전 받는 자/국가/이전
						일시·방법/처리 목적/보유기간을 고지합니다.
					</p>
					<ul>
						<li>예: [수탁사명], [국가], [클라우드 리전], [보유기간]</li>
					</ul>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="rights">
					<h2>7. 이용자 권리</h2>
					<ul>
						<li>열람·정정·삭제·처리정지 요구, 동의 철회 및 회원 탈퇴 가능</li>
						<li>권리 행사는 고객센터(info@queenssmile.co.kr)로 신청</li>
						<li>대리인을 통한 권리 행사 시 위임장 등 제출 필요</li>
					</ul>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="destruction">
					<h2>8. 파기 절차 및 방법</h2>
					<ul>
						<li>보유기간 경과 또는 처리 목적 달성 시 지체 없이 파기</li>
						<li>전자파일: 복구 불가능한 방식으로 영구 삭제</li>
						<li>출력물: 분쇄 또는 소각</li>
					</ul>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="safety">
					<h2>9. 안전성 확보 조치</h2>
					<ul>
						<li>관리적 조치: 내부관리계획 수립, 직원 교육, 접근 권한 최소화</li>
						<li>기술적 조치: 접근통제, 침입탐지/차단, 로그 모니터링</li>
					</ul>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="location">
					<h2>10. 위치정보 처리에 관한 특칙</h2>
					<ul>
						<li>
							기사앱은 <strong>백그라운드 위치 권한</strong>을 사용합니다(운행
							중 앱이 전면에 없을 때도 차량 위치 전송).
						</li>
						<li>
							권한은 단말 설정에서 언제든 변경·철회할 수 있습니다(안드로이드:
							설정 → 위치/앱 권한).
						</li>
					</ul>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="children">
					<h2>11. 아동의 개인정보</h2>
					<p>
						회사는 원칙적으로 만 14세 미만 아동으로부터 개인정보를 수집하지
						않습니다. 필요한 경우 법정대리인 동의를 받습니다.
					</p>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="dpo">
					<h2>12. 개인정보 보호책임자</h2>
					<ul>
						<li>성명: 정수한 / 직책: 대표이사</li>
						<li class="contact">연락처: info@queenssmile.co.kr</li>
					</ul>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="notice">
					<h2>13. 고지의 의무</h2>
					<p>
						본 방침이 변경될 경우 앱 공지 또는 웹사이트 공지사항을 통해
						고지합니다.
					</p>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="contact">
					<h2>14. 문의처</h2>
					<p>
						개인정보 침해에 대한 상담/신고는 한국인터넷진흥원(KISA) 118,
						개인정보분쟁조정위원회 등 공공기관을 이용할 수 있습니다.
					</p>
				</section>
			</article>

			<hr class="divider" style={{ margin: "60px 0" }} />

			{/* <!-- 위치기반서비스 이용약관 --> */}
			<article>
				<h1>위치기반서비스 이용약관</h1>
				<p>
					본 약관은 <strong>퀸즈스마일</strong>(이하 “회사”)가 제공하는
					위치기반서비스의 이용에 관한 회사와 이용자 간 권리·의무 및 책임사항을
					규정합니다.
				</p>

				<p class="meta">
					<strong>시행일:</strong> 2025-08-22
					<br />
					<strong>최종개정:</strong> 2025-08-22
				</p>

				<section style={{ margin: "12px 0" }} class="section" id="purpose-tos">
					<h2>제1조(목적)</h2>
					<p>
						셔틀버스 위치 안내, 도착예측(ETA), 노선 정보 제공, 탑승인원 관리 등
						회사의 위치기반서비스 이용조건과 절차를 규정합니다.
					</p>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="definitions">
					<h2>제2조(정의)</h2>
					<ol>
						<li>
							“위치정보”란 단말기 또는 차량 등에 의해 수집되는 이용자의 지리적
							위치에 관한 정보를 말합니다.
						</li>
						<li>
							“개인위치정보주체”란 개인위치정보가 수집·이용·제공되는 개인을
							말합니다.
						</li>
					</ol>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="effect">
					<h2>제3조(약관의 효력 및 변경)</h2>
					<p>
						약관은 고지와 동시에 효력이 발생합니다. 변경 시 변경 내용을 사전
						고지합니다.
					</p>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="services">
					<h2>제4조(서비스의 내용)</h2>
					<ol>
						<li>실시간 셔틀 위치 지도 표시 및 정류장 도착예측(ETA) 제공</li>
						<li>노선 안내, 탑승인원 관리</li>
						<li>운행 관제 및 안전 관리</li>
					</ol>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="fees">
					<h2>제5조(서비스 이용요금)</h2>
					<p>
						기본 서비스는 무료이며, 별도 유료서비스 도입 시 요금·조건을 사전
						고지합니다.
					</p>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="use-provide">
					<h2>제6조(개인위치정보의 이용·제공)</h2>
					<ol>
						<li>회사는 서비스 제공을 위해 개인위치정보를 수집·이용합니다.</li>
						<li>
							제3자 제공이 필요한 경우 사전에 제공받는 자, 제공 목적, 항목,
							보유기간을 고지하고 동의를 받습니다.
						</li>
						<li>
							개인위치정보는 「위치정보의 보호 및 이용 등에 관한 법률」에 따라
							안전하게 관리합니다.
						</li>
					</ol>
				</section>

				<section
					style={{ margin: "12px 0" }}
					class="section"
					id="retention-tos"
				>
					<h2>제7조(보유기간 및 처리)</h2>
					<p>
						개인위치정보는 이용 목적 달성 시 지체 없이 파기하며, 서비스 품질
						개선·분쟁 대응을 위해 <strong>원시 로그 6개월</strong>, 통계자료는
						비식별 처리 후 <strong>2년</strong> 보관할 수 있습니다.
					</p>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="rights-tos">
					<h2>제8조(개인위치정보주체의 권리)</h2>
					<ol>
						<li>
							개인위치정보주체는 자신의 개인위치정보 처리 사실 확인·열람, 오류
							정정·삭제, 이용·제공 일시·목적·항목 열람을 요구할 수 있습니다.
						</li>
						<li>
							동의의 전부 또는 일부를 철회할 수 있으며, 일시적 중지를 요구할 수
							있습니다.
						</li>
						<li>
							권리 행사는 고객센터(info@queenssmile.co.kr)로 신청할 수 있습니다.
						</li>
					</ol>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="guardian">
					<h2>제9조(법정대리인의 권리)</h2>
					<p>
						개인위치정보주체가 만 14세 미만인 경우 법정대리인은 제8조의 권리를
						행사할 수 있습니다.
					</p>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="pic-location">
					<h2>제10조(위치정보관리책임자)</h2>
					<ul>
						<li>성명: 정수한 / 직책: 대표이사</li>
						<li class="contact">연락처: info@queenssmile.co.kr</li>
					</ul>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="changes">
					<h2>제11조(서비스의 변경·중지)</h2>
					<p>
						천재지변, 설비 점검, 통신망 장애 등 불가피한 사유로 서비스가
						변경·중지될 수 있으며, 가능한 경우 사전 고지합니다.
					</p>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="liability">
					<h2>제12조(손해배상)</h2>
					<p>
						회사의 고의 또는 과실로 개인위치정보의 분실·도난·유출·변조가 발생한
						경우 관련 법령에 따라 손해를 배상합니다.
					</p>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="disclaimer">
					<h2>제13조(면책)</h2>
					<p>
						회사는 천재지변, 통신사 사정, 이용자 귀책 사유 등 불가항력으로 인한
						손해에 책임을 지지 않습니다.
					</p>
				</section>

				<section style={{ margin: "12px 0" }} class="section" id="dispute">
					<h2>제14조(분쟁의 해결)</h2>
					<p>
						분쟁은 협의로 해결하며, 협의가 되지 않는 경우 「위치정보
						분쟁조정위원회」에 조정 신청하거나 관할 법원에 소를 제기할 수
						있습니다.
					</p>
				</section>
			</article>
		</Container>
	);
}
